import { InformationCircleIcon } from '@heroicons/react/24/outline'

import MarkdownText from '../MarkdownText'

/**
 * Titel eines Kulturwerts. Mit onClick wird er wie in DimensionCard zum Button
 * mit Info-Icon, der Host öffnet darüber den Assistenten. Ohne onClick bleibt
 * es reiner Text, so wie im PDF.
 */
const DimensionTitle = ({ title, style, onClick, hasCompletedOnboarding }) => {
  const text = (
    <MarkdownText style={{ ...style, display: 'block' }}>{title}</MarkdownText>
  )

  if (typeof onClick !== 'function') return text

  return (
    <button
      type='button'
      disabled={!hasCompletedOnboarding}
      onClick={onClick}
      className='flex flex-row items-center gap-x-1 text-left'
    >
      {text}
      <InformationCircleIcon
        className={`h-5 w-5 shrink-0 ${!hasCompletedOnboarding ? 'text-lightGrey opacity-50' : 'text-darkBlack'}`}
      />
    </button>
  )
}

export default DimensionTitle
